import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	shortcutActionOpenMenuLabel: {
		id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
		description: 'Label for shortcut action items button',
		defaultMessage: 'open menu',
	},
});
